
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    searchUnits,
    assignBillingAccountToUnits,
    reset
} from './redux/slice';

import { getBillingAccounts } from '../deleteBillingAccount/redux/slice';

const AssignBillingAccount = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, dealerId } = props;
    const dispatch = useDispatch();

    //Redux States
    const { searchUnitsResult, loadingBillingAccounts, openModal, result, selectedDevices } = useSelector(state => state.assignBillingAccountRedux)

    const { billingAccounts } = useSelector(state => state.deleteBillingAccountRedux)

    //Local States
    const [serial, setSerial] = useState("");
    const [step, setStep] = useState(1);
    const [billingAccount, setBillingAccount] = useState(null);
    const [assign, setAssign] = useState(true);
    const [devices, setDevices] = useState([]);

    const searchDevice = () => {
        dispatch(searchUnits({ searchTerm: serial?.trim() }));
    }

    const closeModal = () => {
        setSerial("");
        setStep(1);
        dispatch(reset());
    }

    const applyChanges = () => {
        let unitIds = devices.map((item) => (item?.id))
        let payload = {
            billingAccountId: billingAccount?.id || null,
            unitIds: unitIds
        }
        dispatch(assignBillingAccountToUnits(payload))
    }


    useEffect(() => {
        if (searchUnitsResult) {
            if (!searchUnitsResult?.total) {
                NotificationManager.warning(
                    messages['assign_billing_account_device_has_not_been_found'],
                    messages['assign_billing_account_title'],
                    3000
                );
            } else {
                let currentDevices = devices;
                let newDevice = searchUnitsResult?.items[0];
                let validateNewDevice = currentDevices.some((item) => item.id === newDevice.id);
                if (!validateNewDevice) {
                    currentDevices.push(newDevice);
                    setDevices([...currentDevices]);
                    setSerial("");
                } else {
                    setSerial("");
                    NotificationManager.warning(
                        messages['assign_billing_account_device_is_already_added'],
                        messages['assign_billing_account_title'],
                        3000
                    );
                }
            }

            dispatch(reset({ searchUnitsResult: null }))
        }

        if (selectedDevices && selectedDevices.length > 0) {
            setDevices([...selectedDevices]);
            dispatch(reset({ selectedDevices: [] }))
        }

        if (result) {
            if (!result?.error) {
                let successMessage = assign ? messages['assign_billing_account_multiple_success_message'] : messages['assign_billing_account_multiple_success_message_unassign'];
                NotificationManager.success(
                    successMessage,
                    messages['assign_billing_account_title'],
                    3000
                );
                closeModal();
                tableRef && tableRef?.current?.getData();
            } else if (result?.error) {
                let errorMessage = assign ? messages['assign_billing_account_error_message'] : messages['assign_billing_account_error_message_unassign'];
                NotificationManager.error(
                    errorMessage,
                    messages['assign_billing_account_title'],
                    3000
                );
                dispatch(reset())
            }
        }

    }, [searchUnitsResult, result, selectedDevices])

    useEffect(() => {
        if (openModal && dealerId) {
            dispatch(getBillingAccounts({ dealerId: dealerId }))
        }
    }, [dealerId])

    let validateStepOne = step === 1
    let validateStepTwo = step === 2
    
    return (
        <Modal
            open={openModal}
            title={messages['assign_billing_account_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loadingBillingAccounts}
        >
            <ModalBody>
                {
                    validateStepOne &&
                    <div style={{ padding: '0 10px', height: "600px" }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    {

                                        <Input
                                            label={messages['assign_billing_account_input']}
                                            placeholder={messages['assign_billing_account_input']}
                                            value={serial}
                                            required
                                            requiredMessage={messages['required_field']}
                                            onChange={(value) => setSerial(value)}
                                        />
                                    }
                                </Form>
                            </Grid>
                            {
                                <Grid item xs={2}>
                                    <div style={{ marginTop: 26 }}>
                                        <Button
                                            className="btn-dark-blue"
                                            onClick={() => formRef?.current?.submit()}
                                        >
                                            {messages['common_add']}
                                        </Button>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                        {devices?.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        setDevices([...currentDevices]);
                                    }}
                                >
                                    {
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_billing_account_imei']}</label><span>{item.imei}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_billing_account_serial']}</label><span>{item.esn}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_billing_account_model']}</label><span>{item?.deviceModel?.name}</span>
                                            </div>
                                            {
                                                item?.unitConfig?.billingAccount &&
                                                <div>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_billing_account_current_billing_account']}</label><span>{item?.unitConfig?.billingAccount?.name}</span>
                                                </div>
                                            }
                                        </div>
                                    }
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }
                {
                    validateStepTwo &&
                    <div style={{ padding: '0 10px' }}>
                        <Form
                            ref={formTwoRef}
                            onSubmit={() => {
                                return true
                            }}
                            onValidSubmit={() => {
                                if (!billingAccount && assign) {
                                    NotificationManager.error(
                                        messages['assign_billing_account_select_billing_account'],
                                        messages['assign_billing_account_title'],
                                        3000
                                    );
                                    return
                                }
                                applyChanges()
                            }}
                        >
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={10}>
                                    <div className='filters-type'>
                                        <FormControlLabel
                                            value={true}
                                            control={<Radio onClick={() => {
                                                setAssign(true);

                                            }} checked={assign} color="primary" />}
                                            label={messages['assign_billing_account_assign']}
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="start"
                                            control={<Radio onClick={() => {
                                                setAssign(false);
                                                setBillingAccount(null);
                                            }} checked={!assign} color="primary" />}
                                            label={messages['assign_billing_account_unassign']}
                                            labelPlacement="end"
                                        />
                                    </div>
                                </Grid>
                                {
                                    assign &&
                                    <Grid item xs={10}>
                                        <Select
                                            id="list-new-billing-account"
                                            value={billingAccount || []}
                                            options={billingAccounts}
                                            label={messages['assign_billing_account_label']}
                                            placeholder={messages['assign_billing_account_label']}
                                            onChange={(item) => setBillingAccount(item)}
                                            valueField="id"
                                            textField="name"
                                            required
                                            requiredMessage={messages['required_field']}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Form>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {step === 2 && !single &&
                    <Button
                        className="btn btn-cancel btn-gray"
                        onClick={() => setStep(1)}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    disabled={step === 1 && devices.length === 0}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (step < 2) setStep(step + 1);
                        else formTwoRef?.current?.submit();
                    }}
                >
                    {step === 1 ? messages['common_next'] : assign ? messages['assign_billing_account_assign'] : messages['assign_billing_account_unassign']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default AssignBillingAccount;